import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';


const ProjectDetails = () => {
    const { id } = useParams()

    const [projects, setProjects] = useState([])
    const [loading, setLoading] = useState(true)
    useEffect(() => {
        fetch('/projects.json')
            .then(res => res.json())
            .then(data => {
                setProjects(data)
                setLoading(false)
            })
    }, [])
    if (loading) {
        return <p>Loading....</p>
    }
    const project = projects?.find(project => project.id === id)
    const { name, technology, link, githubClient, githubServer, github, description, mobileImg, img, img1, img2, img3 } = project

    return (
        <div className='my-10 min-h-screen'>
            <h1 className='text-4xl font-bold text-center my-2'>{name}</h1>
            <div data-aos="fade-left"
                data-aos-duration="3000" className="carousel w-4/5 lg:w-3/4 mx-auto  p-4 space-x-4 bg-neutral rounded-box">
                <div id="item1" className="carousel-item hero w-full">
                    <img src={img1} alt='' className="w-full lg:w-3/4 h-96 mx-auto" />
                </div>
                <div id="item2" className="carousel-item w-full">
                    <img src={img2 || img} alt='' className="w-full lg:w-3/4 h-96 mx-auto" />
                </div>
                <div id="item3" className="carousel-item w-full">
                    <img src={img3 || mobileImg} alt='' className="w-full lg:w-3/4 h-96 mx-auto" />
                </div>
            </div>
            <div>
                <div className="flex justify-center w-full py-2 gap-2">
                    <a href="#item1" className="btn btn-xs">1</a>
                    <a href="#item2" className="btn btn-xs">2</a>
                    <a href="#item3" className="btn btn-xs">3</a>
                </div>
                <div className='flex flex-col md:flex-row justify-center items-center'>
                    <a className='btn btn-success btn-sm ml-2 my-2' href={link} target="_blank" rel='noreferrer'>Live site</a>
                    {github && <a className='btn btn-success btn-sm ml-2 my-2' href={github} target="_blank" rel='noreferrer'>Github</a>}
                    {githubClient && <a className='btn btn-success btn-sm ml-2 my-2' href={githubClient} target="_blank" rel='noreferrer'>Github client</a>}
                    {githubServer && <a className='btn btn-success btn-sm ml-2 my-2' href={githubServer} target="_blank" rel='noreferrer'>Github server</a>}
                </div>
            </div>
            <div className='p-5 mx-5'>
                <p className='text-center'><span className='text-xl font-bold'>Used Technology: </span>{technology.split(' ').map(t => <button className='btn btn-xs m-2'>{t}</button>)}</p>
                <p className='text-xl font-bold'>Project Details:</p>
                <ul data-aos="fade-up"
                    data-aos-duration="3000" className='p-5'>{description.split('.').map((d, index) => <li key={index} className='list-item list-disc'>{d}</li>)}</ul>
            </div>
        </div>
    );
};

export default ProjectDetails;